import { ButtonDownloadComponent, ButtonsActionsTableComponent } from '@app/shared';
import { EventEmitter } from '@angular/core';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';

export class DocumentInventoryFormConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la modal
  settingsModal = {};
  accionModal: any;

  constructor() {
    const self = this;
    this.settings = {
      selectMode: 'multi',
      noDataMessage: 'No hay resultados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        dependencia: {
          title: 'Dependencia',
          filter: {
            inputClass: 'form-control',
          },
        },
        serie: {
          title: 'Serie',
          filter: {
            inputClass: 'form-control',
          },
        },
        subserie: {
          title: 'Subserie',
          filter: {
            inputClass: 'form-control',
          },
        },
        tipo_documental: {
          title: 'Tipo documental',
          filter: {
            inputClass: 'form-control',
          },
          // sortDirection: 'desc'
        },
        radicado: {
          title: 'Radicado',
          filter: {
            inputClass: 'form-control',
          },
        },
        fecha_documento: {
          title: 'Fecha documento',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            const formatted = new DateFormatPipe().transform(row.fecha_documento,'DD/MM/YYYY' );
            return formatted;
          }
          
        },
        fecha_vencimiento: {
            title: 'Fecha vencimiento',
            filter: {
                inputClass: 'form-control',
              },
              valuePrepareFunction: (cell: any, row: any) => {
                const formatted = new DateFormatPipe().transform(row.fecha_vencimiento,'DD/MM/YYYY' );
                return formatted;
              }
        },
        expediente: {
            title: 'Expediente',
            filter: {
                inputClass: 'form-control',
              },
        },
        fecha_expediente: {
            title: 'Fecha expediente',
            filter: {
                inputClass: 'form-control',
              },
              valuePrepareFunction: (cell: any, row: any) => {
                const formatted = new DateFormatPipe().transform(row.fecha_expediente,'DD/MM/YYYY' );
                return formatted;
              }
        },
        fecha_asociacion: {
            title: 'Fecha asociacion',
            filter: {
                inputClass: 'form-control',
              },
              valuePrepareFunction: (cell: any, row: any) => {
                const formatted = new DateFormatPipe().transform(row.fecha_asociacion);
                return formatted;
              }
        },
        id: {
          title: 'Documento',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
    this.settingsModal = {
      selectMode: 'external',
      noDataMessage: 'No hay resultados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        numero: {
          title: 'Número',
          filter: {
            inputClass: 'form-control',
          },
        },
        fecha: {
            title: 'Fecha expediente',
            filter: {
                inputClass: 'form-control',
              },
              valuePrepareFunction: (cell: any, row: any) => {
                const formatted = new DateFormatPipe().transform(row.fecha,'DD/MM/YYYY' );
                return formatted;
              }
        }
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/document-inventory-form/shared/document-inventory-form.config.service.ts